import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaPerfFeeAmortizedMenuRegistry = {
    personalize_nebulaPerfFeeAmortized: {
        label: "Nebula Perf Fee Amortized",
        link: PAGE_URL.NEBULA_PERF_FEE_AMORTIZED_PAGE,
        key: PAGE_URL.NEBULA_PERF_FEE_AMORTIZED_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaPerfFeeAmortizedMenuRegistry;
